import React from 'react';
import bem from 'utils/bem.js';
import { VideoButton } from '../../components/VideoButton';
import { useSwitchCamera } from '../MediaSettings/useSwitchCamera';
import { useBluetoothAudio } from '../MediaSettings/useBluetoothAudio';

const { block } = bem('bluetooth-audio-button');
export const BluetoothAudioButton = (props) => {
    const { toggleBluetoothAudio, hasBluetoothAudioDevice, isBluetoothAudioOn } = useBluetoothAudio();

    if (!hasBluetoothAudioDevice) { return null; }
    return (
        <VideoButton className={ block() }
                     name={ isBluetoothAudioOn ? 'bluetooth-shadow' : 'bluetooth' }
                     active={ isBluetoothAudioOn }
                     onClick={ toggleBluetoothAudio }
                     { ...props }g
        />
    )
}
